export const testimonials = [
  {
    name: "陆一鸣",
    role: "互联网从业者",
    content:
      "最有用的是时间线。以前看热点只能看到零散的转发，现在能把前后顺序对上，判断起来清楚很多。",
  },
  {
    name: "沈知微",
    role: "自由撰稿人",
    content:
      "写稿前会来这里过一遍资料。来源标注得比较克制，哪些是公开可查、哪些还待确认，一眼能分出来。",
  },
  {
    name: "何嘉禾",
    role: "消费者权益关注者",
    content:
      "维权那几篇的流程写得很实在，步骤能直接照着做，不是那种看完还是不知道从哪开始的文章。",
  },
  {
    name: "郑思远",
    role: "高校媒介课教师",
    content:
      "把摆拍识别、传闻溯源拆成可操作的动作，很适合拿来做课堂讨论的案例材料。",
  },
];